import AdminLayerBlueprint from "components/blueprints/AdminLayerBlueprint";
import React from "react";
import AdminNotificationsOverview from "./AdminNotificationsOverview";
import AdminNotificationsList from "./AdminNotificationsList";

function AdminNotificationsPage() {
  return (
    <div className="min-h-screen bg-gray-100 py-2">
      <div className="container mx-auto my-6 flex">
        <section id="left" className="w-1/4 pr-2">
          <AdminNotificationsOverview />
        </section>
        <section id="right" className="w-3/4 pl-2">
          <AdminNotificationsList />
        </section>
      </div>
    </div>
  );
}

export default AdminLayerBlueprint(AdminNotificationsPage);
